import { render, staticRenderFns } from "./OfficialCompensation.vue?vue&type=template&id=a2f9a4cc&scoped=true"
import script from "./OfficialCompensation.vue?vue&type=script&lang=js"
export * from "./OfficialCompensation.vue?vue&type=script&lang=js"
import style0 from "./OfficialCompensation.vue?vue&type=style&index=0&id=a2f9a4cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f9a4cc",
  null
  
)

export default component.exports